import { Component, Input, OnInit } from '@angular/core';

import { currency } from 'app/constants/currency.constants';
import { DateService, HelperService } from 'app/services';
import { log } from 'console';

@Component({
  selector: 'app-repair-order-auth-logs',
  templateUrl: './repair-order-auth-logs.component.html',
  styleUrls: ['./repair-order-auth-logs.component.scss'],
})
export class RepairOrderAuthLogsComponent implements OnInit {

  @Input() pdfAuthHistory: any;
  @Input() timezone: any;

  constructor(private dateService: DateService){}

  ngOnInit() {
    this.pdfAuthHistory.forEach(element => {
      if(element.method === 'inPerson' || element.method === 'online'){
        element.phone = '';
        element.email = '';
      }
      element.dateTime = this.dateService.getCurrentDateTimeTz(new Date(element.dateTime).getTime(), this.timezone);
    });
  }

  openUrl(url){
    if(url) window.open(url, '_blank')
  }

}